import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActiveCancelModel } from '@apps-common/types/management/unit'

export const cancelUnitActive = async (unitId: string, model: IActiveCancelModel): Promise<boolean> =>
  axios.post(`/management/unit/cancelunitactive?unitId=${unitId}`, model).then((res) => res?.data?.result)

type Props = {
  unitId: string
  model: IActiveCancelModel
}

export const useManagementCancelUnitActive = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['cancelUnitActive'],
    mutationFn: ({ unitId, model }: Props) => cancelUnitActive(unitId, model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Cancelled active device.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to cancel active device, please try again.')
      }
    },
    throwOnError: false
  })
